export default __webpack_public_path__ + "static/media/completeId.6769d996.png";